import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../../services/globals.service';


@Component({
  selector: 'app-clients-list',
  templateUrl: './clients-list.component.html',
  styleUrls: ['./clients-list.component.css']
})
export class ClientsListComponent implements OnInit {
  selectedClient: IClient;
  clients: IClient[];

  constructor(http: HttpClient,
    private globals: Globals,
    @Inject('BASE_URL') baseUrl: string) {
    var url = baseUrl + 'api/clients';

    http.get<IClient[]>(url).subscribe(result => {
      this.clients = result;
    },
      error => console.error(error));
  }

  onSelect(client: IClient) {
    this.selectedClient = client;
    this.globals.cc = this.selectedClient.umdncodep;
    this.globals.company = this.selectedClient.company;
    console.log("Client with Id " + this.selectedClient.id + " (" + this.selectedClient.umdncodep + ") has been selected");
  }

  ngOnInit() {
  }

}
